import jwtDecode from 'jwt-decode'
import store2 from 'store2'

const service = {
  state: {
    'ID': '',
    'user_email': '',
    'firstname': '',
    'lastname': '',
    'acf': {
      'address': '',
      'phone': '',
      'city': '',
      'state': ''
    }
  }
}
service.removeToken = function () {
  store2.session.remove('token')
  Object.assign(service.state, {ID: null})
}
service.getToken = function () {
  return store2.session.get('token')
}
service.setToken = function (token) {
  store2.session.set('token', token)
  service.setUser(jwtDecode(token).user)
}
service.setUser = function (user) {
  Object.assign(service.state, user)
}
service.getUser = function (user) {
  return service.state
}
if (service.getToken()) {
  service.setToken(service.getToken())
}
export default service



// WEBPACK FOOTER //
// ./src/service/auth.js